import axios from 'axios';

const state = {
  notifications: null,
};

const mutations = {
  setNotifications: (st, payload) => {
    st.notifications = payload;
  },
};

const actions = {
  getNotifications: ({ commit }) => {
    axios.get(`/clusters/users/notifications/all`).then(res => commit('setNotifications', res));
  },
};

export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/notifications.js